import { Component, Output, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto } from 'sg-api';
import { Subject } from 'rxjs';
import { SgkbConstains } from '../../../../../sg-kb-shared/sg-kb-constans';
import { Sgkb701dSearchConditionComponent } from '../../components/sgkb701d-search-condition/sgkb701d-search-condition.component';
import { Sgkb701dSearchResultComponent } from '../../components/sgkb701d-search-result/sgkb701d-search-result.component';

@Component({
  selector: 'app-sgkb701d',
  templateUrl: './sgkb701d.component.html',
  styleUrl: './sgkb701d.component.scss'
})
export class Sgkb701dComponent implements OnInit, OnDestroy {

  @Output() errorMessageModelArray: Array<SgAriaMessage>;
  /** 遷移元ステータス */
  @Output() mode: string;
  /** 包括契約検索APIレスポンス */
  @Output() incCtrSearchResultList: Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto;
  /** 子コンポーネント */
  @ViewChild(Sgkb701dSearchConditionComponent) sgkb701dSearchConditionComponent!: Sgkb701dSearchConditionComponent;
  @ViewChild(Sgkb701dSearchResultComponent) sgkb701dSearchResultComponent!: Sgkb701dSearchResultComponent;

  private onDestroy$ = new Subject();

  /** 検索条件フォームグループ */
  kensakuJyoukenForm: UntypedFormGroup;

  /** 検索結果表示フラグ */
  showResult: boolean = false;
  /** クリア押下フラグ */
  clearExeFlg: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder
  ) {
    this.kensakuJyoukenForm = this.fb.group({});
  }

  /**
   * 初期処理
   * @memberof Sgkb701dComponent
   */
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      // 画面遷移時のパラメータ取得
      // 遷移パラメータ  read：参照、create：登録、midterm_change：期中変更、
      //                renewal：契約更改、cancel：解約、approve：承認、delete：取消
      this.mode = params.get('mode');
      if (this.mode == 'update') {
        this.mode = params.get('operationType');
      }
      // 再表示時には子コンポーネントの初期処理は実行されないため
      // 親コンポーネントから子コンポーネントの初期処理を呼び出す。
      // また初回表示時は子コンポーネントが存在しないため以下の処理は実行されない
      if (this.sgkb701dSearchConditionComponent) {
        this.sgkb701dSearchConditionComponent.mode = this.mode;
        this.sgkb701dSearchConditionComponent.ngOnInit();
        this.sgkb701dSearchConditionComponent.onClickClear();
      }
      if (this.sgkb701dSearchResultComponent) {
        this.sgkb701dSearchResultComponent.mode = this.mode;
        this.sgkb701dSearchResultComponent.ngOnInit();
      }
    });
  }

  /**
   * サブミット処理
   * @memberof Sgkb701dComponent
   */
  onSubmit(): void {
    let messageItem: SgAriaMessage;
    if (messageItem && messageItem != null) {
      messageItem = {};
      messageItem.message = "エラーメッセージ";
      messageItem.messageClass = "mat-card-background-error";
      messageItem.icon = "cancel";
      messageItem.iconClass = "mat-icon-color-error";
      this.errorMessageModelArray.push(messageItem);
      messageItem = {};
      messageItem.message = "警告メッセージ";
      messageItem.messageClass = "mat-card-background-warning";
      messageItem.icon = "warning";
      messageItem.iconClass = "mat-icon-color-warning";
      this.errorMessageModelArray.push(messageItem);
    }
  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb714dBulksetComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.kensakuJyoukenForm.clearValidators();
    this.kensakuJyoukenForm.updateValueAndValidity();
    this.kensakuJyoukenForm.removeControl('kensakuJyoukenForm');
  }

  /**
   * 検索結果の行選択処理
   * @memberof Sgkb701dComponent
   */
  onClickRow(row): void {
    /** 包括割引契約登録画面への遷移 */
    this.router.navigate(['/sgkb/sgkb708d', {
      // 包括お客さま番号
      inclusioncontractVisitornumber: row.inclusioncontractVisitornumber || "",
      // 包括契約履歴番号
      inclusioncontractRrkno: row.inclusioncontractRrkno || "",
      // 包括契約年度内通番号
      inclusioncontractYearnaiSrno: row.inclusioncontractYearnaiSrno || "",
      // 申請状況コード
      appJokyo: this.disionAppJokyoCd(row) || "",
      // 包括契約登録操作コード
      mode: this.mode || ""
    }]);
  }

  /**
   * 申請状況コード判定
   * @memberof Sgkb701dComponent
   */
  disionAppJokyoCd(row): string {
    // 包括契約状態コードが 解約 の場合は解約申請状況コードを設定する
    if (row.inclusioncontractStcode === SgkbConstains.CODE.HOUKATSU_CNTRCT_CD.CANCEL) {
      return row.inclusioncontractBreakereqestJokycd;
    }
    // それ以外の場合
    return row.inclusioncontractRegistrationapplicationJokycd;
  }

  /**
   * 検索条件コンポーネントからの受領値設定
   * @memberof Sgkb701dComponent
   */
  setValue(eventData: any): void {
    this.showResult = eventData.showResult;
    this.clearExeFlg = eventData.clearExeFlg;
    this.incCtrSearchResultList = eventData.incCtrSearchResultList;
  }
}
